import { removeToken } from "../setup/api";

export default {
  getConfig(context) {
    return new Promise((resolve, reject) => {
      try {
        const existingConfig = context.state?.config || {};
        const fallbackConfig = {
          title: "ZeusPay"
        };
        const config = {
          ...fallbackConfig,
          ...existingConfig
        };

        context.commit("setConfig", config);

        // set title
        if (config.title) {
          document.title = config.title;
        }

        resolve(config);
      } catch (err) {
        reject(err);
      }
    });
  },

  postLogin(context) {
    return new Promise((resolve, reject) => {
      context.commit("setLoading", true);
      context
        .dispatch("user/get")
        .then(user => {
          resolve(user);
          context.commit("user/setLogged", true);
        })
        .catch(reject)
        .finally(() => {
          context.commit("setLoading", false);
        });
    });
  },

  logout(context) {
    return new Promise(resolve => {
      removeToken();
      context.commit("user/reset");
      resolve();
    });
  }
};
